/* eslint-disable camelcase */
import { FlatRoute } from '../domain/route/FlatRoute';
import { RouteStatus } from '../domain/route/RouteStatus';
import { FlatRouteEntry } from '../entries/FlatRouteEntry';

export class FlatRouteMapper {
  static toDomain(props: FlatRouteEntry): FlatRoute {
    const { id, vehicle_id, label, plan_id, plan_label, plan_execution_date, status } = props;

    return FlatRoute.create(
      {
        vehicle_id,
        label,
        plan_id,
        plan_label,
        plan_execution_date,
        status: status as RouteStatus,
      },
      id
    );
  }
}
